module.exports = "/images/Portugal.png?2d991698367c19a7be7f7a948a42d1e8";